import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "error", "success", "saving", "save" ]

  // use decryptOnConnect if you load your autodecrypt data later via turbo frame, then the event will already be fired
  static values = {
    url: { type: String },
    key: { type: String },
    checkboxId: { type: String },
    textfieldId: { type: String },
    wrap: { type: String }
  }

  isUploading;

  connect() {
    // console.log("togglerConnected")
    // this.log()
    this.reset()
    this.textfield().addEventListener("input", this.textChanged.bind(this))
  }

  currentValue() {
    return {
      checkbox: this.checkbox().checked,
      textfield: this.textfield().value
    }
  }

  getCsrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");
  }

  requestHeaders() {
    return {
      "Content-Type": "application/json",
      "X-CSRF-Token": this.getCsrfToken(),
    }
  }

  requestData() {
    let requestData = {}
    requestData[this.wrapValue] = {}
    requestData[this.wrapValue][this.keyValue] = this.currentValue()
    return requestData
  }
  async upload() {
    if (this.isUploading) return; // no mess with running uploads

    if (!this.checkbox().checked) {
      this.textfield().value = null;
    }
    //
    // console.log("toggled")
    // this.log()
    this.startUpload()

    try {
      const response = await fetch( this.urlValue, {
        method: "POST",
        headers: this.requestHeaders(),
        body: JSON.stringify(this.requestData()),
      });


      if (response.ok) {
        this.successResult(await response.text())
      } else {
        this.errorResult(await response.text())
      }

    } catch (error) {
      this.errorResult(error);
    }
  }

  startUpload() {
    this.isUploading = true;
    this.checkbox.disabled = true
    this.textfield.disabled = true
    this.errorTarget.classList.add("hidden")
    this.successTarget.classList.add("hidden")
    this.savingTarget.classList.remove("hidden")
    this.saveTarget.classList.add("hidden")
    this.errorTarget.textContent = null;
  }

  successResult(message) {
    this.checkbox.disabled = false
    this.textfield.disabled = false
    this.errorTarget.classList.add("hidden")
    this.successTarget.classList.remove("hidden")
    this.successTarget.textContent = message;
    this.savingTarget.classList.add("hidden")
    this.saveTarget.classList.add("hidden")
    this.errorTarget.textContent = null;
    this.isUploading = false;
  }

  errorResult(message) {
    this.checkbox.disabled = false
    this.textfield.disabled = false
    this.errorTarget.classList.remove("hidden")
    this.successTarget.classList.add("hidden")
    this.savingTarget.classList.add("hidden")
    this.saveTarget.classList.add("hidden")
    this.errorTarget.textContent = message;
    this.isUploading = false;
  }

  reset() {
    this.checkbox.disabled = false
    this.textfield.disabled = false
    this.errorTarget.classList.add("hidden")
    this.successTarget.classList.add("hidden")
    this.saveTarget.classList.add("hidden")
    this.savingTarget.classList.add("hidden")
    this.isUploading = false;
  }

  checkbox() {
    return document.getElementById(this.checkboxIdValue)
  }

  textfield() {
    return document.getElementById(this.textfieldIdValue)
  }

  textChanged() {
    this.successTarget.classList.add("hidden")

    if (this.checkbox().checked) {
      this.saveTarget.classList.remove("hidden")
    }
  }

  log () {
    console.log(
      " Url: " + this.urlValue +
      " Key: " + this.keyValue +
      " chk: " + this.checkboxIdValue +
      " txt: " + this.textfieldIdValue +
      " wrp: " + this.wrapValue +
      " Val: " + this.currentValue()
    )
  }
}
